import { Fragment, useState, useRef, useEffect } from "react";
import Button from "../Common/Button/Button";
import { InfoPairLabel } from "../Common/Typography/AppTypography";
import Grid from "@mui/material/Grid2";
import { Box, Paper } from "@mui/material";
import FormInput from "../Common/FormInputs/MuiTextField";

const UploadPSNDealerMapping = ({
  setAlert,
  deviceDealer: {
    uploadPSNDealerFileInProgress,
    uploadPSNDealerFileSuccess,
    uploadPSNDealerFileFailure,
  },
  uploadPSNDealerFile,
}) => {
  const [uploadedPSNDealerFile, setUploadedPSNDealerFile] = useState("");
  const uploadedPSNDealerFileRef = useRef();

  useEffect(() => {
    if (uploadPSNDealerFileSuccess) {
      handleUploadPSNDealerFileReset();
    }
  }, [uploadPSNDealerFileSuccess]);

  function handleUploadPSNDealerFileMapping() {
    if (
      !uploadedPSNDealerFile ||
      uploadedPSNDealerFile === "" ||
      !uploadedPSNDealerFile.name.endsWith(".csv")
    ) {
      setAlert("Invalid File", "danger");
      return;
    }

    let formData = new FormData();
    formData.append("csv_file", uploadedPSNDealerFile);

    uploadPSNDealerFile(formData);
  }

  function handleUploadPSNDealerFileReset() {
    setUploadedPSNDealerFile("");

    // uploadedPSNDealerFileRef.current.value = ""
    if (uploadedPSNDealerFileRef.current) {
      uploadedPSNDealerFileRef.current.value = "";
    }
  }

  return (
    <Fragment>
      <Paper
        elevation={3}
        sx={{
          p: { xs: 2, md: 3 },
          borderRadius: 2,
          mb: 1,
        }}
      >
        <Box sx={{ mt: 1 }}>
          <Grid container spacing={2} alignItems="center">
            <Grid size={{ xs: 12, sm: "auto" }}>
              <InfoPairLabel strong sx={{ color: "text.primary" }}>
                Upload CSV File:
              </InfoPairLabel>
            </Grid>

            <Grid size={{ xs: 12, sm: 4 }}>
              <FormInput
                type="file"
                name={uploadedPSNDealerFile?.name ?? uploadedPSNDealerFile}
                accept=".csv"
                // inputRef attaches to the underlying <input type="file"> element
                inputRef={uploadedPSNDealerFileRef}
                placeholder="Upload CSV File"
                onChange={(e) => setUploadedPSNDealerFile(e.target.files[0])}
                disabled={uploadPSNDealerFileInProgress}
                fullWidth
              />
            </Grid>
          </Grid>

          <Box sx={{ display: "flex", gap: 2, mt: 4 }}>
            <Button
              onClick={handleUploadPSNDealerFileMapping}
              loading={uploadPSNDealerFileInProgress}
              disabled={uploadPSNDealerFileInProgress ? true : false}
            >
              Upload
            </Button>

            <Button
              variant="ghost"
              onClick={handleUploadPSNDealerFileReset}
              disabled={uploadPSNDealerFileInProgress}
            >
              Reset
            </Button>
          </Box>
        </Box>
      </Paper>
    </Fragment>
  );
};

export default UploadPSNDealerMapping;
